import React, { useState, useEffect } from "react";

export default function ReportsGroupsAssignment() {
  const [reports, setReports] = useState([]);
  const [groups, setGroups] = useState([]);
  const [reportGroupsMap, setReportGroupsMap] = useState({}); // { reportId: Set(groupIds) }
  const [loading, setLoading] = useState(true);

  // Fetch data on mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [reportsRes, groupsRes, rgRes] = await Promise.all([
          fetch(process.env.REACT_APP_BACKEND_URL+"/button_report_definitions"),
          fetch(process.env.REACT_APP_BACKEND_URL+"/report_groups"),
          fetch(process.env.REACT_APP_BACKEND_URL+"/report_report_groups")
        ]);

        const reportsData = await reportsRes.json();
        const groupsData = await groupsRes.json();
        const rgData = await rgRes.json();

        setReports(reportsData || []);
        setGroups(groupsData || []);

        const rgDict = {};
        (rgData || []).forEach(rg => {
          if (!rgDict[rg.report_id]) rgDict[rg.report_id] = new Set();
          rgDict[rg.report_id].add(rg.report_group_id);
        });
        setReportGroupsMap(rgDict);

      } catch (err) {
        console.error("Failed to fetch report data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <p>Atskaišu ielāde...</p>;

  // Handle toggling a report-group assignment
  const toggleGroup = async (reportId, groupId) => {
    const currentSet = new Set(reportGroupsMap[reportId] || []);
    const isAssigned = currentSet.has(groupId);

    if (isAssigned) {
      // Remove report from group
      await fetch(process.env.REACT_APP_BACKEND_URL+`/report_report_groups/${reportId}/${groupId}`, {
        method: "DELETE"
      });
      currentSet.delete(groupId);
    } else {
      // Add report to group
      await fetch(process.env.REACT_APP_BACKEND_URL+`/report_report_groups`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ report_id: reportId, report_group_id: groupId })
      });
      currentSet.add(groupId);
    }

    setReportGroupsMap(prev => ({ ...prev, [reportId]: currentSet }));
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Notikumu grupu piesaiste</h2>

      {reports.map(report => (
        <div key={report.id} className="mb-6 border rounded p-4 shadow">
          <h3 className="font-semibold mb-2">{report.serial}#{report.button_id} - {report.report_text}</h3>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
            {groups.map(group => {
              const checked = reportGroupsMap[report.id]?.has(group.id) || false;
              return (
                <label
                  key={group.id}
                  className="flex items-center gap-2 border p-2 rounded hover:bg-gray-100"
                >
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => toggleGroup(report.id, group.id)}
                  />
                  {group.name} {group.is_active ? "(Active)" : "(Inactive)"}
                </label>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
